import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function RadnoPravo() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Radno pravo" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Radno pravo</h2>
              <p>
                <strong>Studijski program:</strong> Pravo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Radno pravo
              </p>
              <p>
                <strong>Nastavnik:</strong>
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 4
              </p>
              <p>
                <strong>Uslov:</strong> Nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Osnovni cilj predmeta Radno pravo je učenje opštih instituta
                radnog i socijalnog prava. Prvenstveni cilj je da se studenti
                upoznaju sa modelima radnog i socijalnog prava u Crnoj Gori u
                karakterističnim državama i međunarodnim radnim standardima.
                Takođe studenti će se upoznati sa funkcionisanjem tržišta rada a
                naročito sa vidovima ostvarivanja i zaštite prava iz radnih
                odnosa kako bi u toku radnog staža na najbolji mogući način
                zaštitili sebe a i druge.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Polaganjem predmeta Radno pravo student stiče znanja iz domena
                radnog i socijalnog prava neophodna za bavljenje poslovima
                pravnika po svršetku studijskog programa Pravo. Ovaj predmet
                proučava radne odnose, kategorije i institucije vezane za
                ljudska prava na radu, u vezi sa radom i povodom rada
                zaposlenih. Predmet radno pravo proučava naučne metode čije su
                glavne karakteristike: objektivnost i povjerljivost; preciznost
                i sistematičnost. Nakon uspješno savladanog predmeta Radno pravo
                studenti će biti u mogućnosti da pokažu razumijevanje osnovnih
                pojmova u oblasti radnog prava moći će da objasne šta znači
                individualni a šta kolektivni ugovor. Takođe studenti će biti
                osposobljeni da uz pravnu argumentaciju na osnovu činjeničnog
                stanja pruže pravni savjet za zaštitu prava iz radnog odnosa i
                da mogu uz odgovarajući pravni izvor sastaviti individualni
                ugovor o radu. Isto tako studenti će biti u mogućnosti da
                objasne osnovne karakteristike i postupak zaštite kolektivnih
                prava iz radnog odnosa kao i da objasne način ostvarivanja prava
                po osnovu rada kao što su prava iz zdravstvenog osiguranja,
                penzijsko – invalidska prava i prava u slučaju nezaposlenosti.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                Sadržaj predmeta obuhvata definisanje pojma radnog prava koje
                pripada različitim pravnim sastavima; javnom i privatnom, njegov
                razvoj i uticaj na održanje mira u svijetu, socijalnu pravdu te
                konsolidaciju nacionalnih radnih zakonodavstava. Posebna se
                pažnja posvećuje globalnim (uticaj Međunarodne organizacije rada
                i njene normativne djelatnosti) i regionalnim instrumentima
                radnog prava.
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Osnovni oblici rada na predmetu su: predavanja i vežbe,
                samostalni rad (seminarski rad i interaktivna nastava).
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>3P</td>
                    <td>Pojam i predmet Radnog prava</td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>3P</td>
                    <td>Izvori Radnog prava</td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>3P</td>
                    <td>Pojam radnog odnosa</td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>3P</td>
                    <td>
                      Zasnivanje radnog odnosa, specifični radni odnosi,
                      zasnivanje radnog odnosa sa stranim državljanima
                    </td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>3P</td>
                    <td>Individualna i kolektivna prava iz radnog odnosa</td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>3P</td>
                    <td>Radni odnosi i rad van radnog odnosa</td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td></td>
                    <td>Kolokvijum I</td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>3P</td>
                    <td>Rad u državnim organima</td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>3P</td>
                    <td>Ostvarivanje prava zaposlenih</td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>3P</td>
                    <td>Zaštita prava zaposlenih</td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>3P</td>
                    <td>
                      Zaštita na radu, zaštita na radu po međunarodnim
                      konvencijama, mjere zaštite na radu, povrede na radu,
                      prava po osnovu povrede na radu
                    </td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td></td>
                    <td>Kolokvijum II</td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>3P</td>
                    <td>
                      Socijalno, zdravstveno, penzijsko i invalidsko osiguranje
                    </td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>3P</td>
                    <td>Kolektivni ugovori</td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>3P</td>
                    <td>Organizacija poslodavaca i zaposlenih</td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td></td>
                    <td>Sveobuhvatni ispit</td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td></td>
                    <td>Ovjera semestra i upis ocjena</td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td></td>
                    <td>Popravni ispitni rok</td>
                  </tr>
                </tbody>
              </table>
              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 3 č / 2.15h</td>
                            <td>Ukupno: 60 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 3 č / 2.15h</td>
                            <td>Nastava + završni ispit: 45 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe:</td>
                            <td>Priprema i ovjera semestra: 4 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 11 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default RadnoPravo;
